import type { CenterProps, MotionPropsFor } from '@hover/blueprint';
import {
  Center,
  Motion,
  forwardRef,
  mapResponsive,
  motion,
  useTheme,
} from '@hover/blueprint';
import { AnimatePresence } from 'framer-motion';
import React from 'react';

import { fadePresence } from 'src/shared/utils/motion';

import { MaterialCalloutButton } from '../materialCallouts';

import { useCustomization } from './useCustomization';
import { useCustomizationMaterialCallout } from './useCustomizeMaterialCallout';

const MotionCenter = motion(Center);

export interface CustomizeMobileCalloutProps
  extends MotionPropsFor<CenterProps> {}

export const CustomizeMobileCallout = forwardRef<
  CustomizeMobileCalloutProps,
  'div'
>(({ display, ...props }, ref) => {
  const { sizes, space } = useTheme();
  const { isCustomizing, category } = useCustomization();

  const materialCallout = useCustomizationMaterialCallout();
  const isVisible = !!materialCallout && !!category;

  return (
    <Motion.Soft>
      <MotionCenter
        animate={{
          height: isVisible ? sizes[500] : '0px',
          marginBottom: isVisible ? space[500] : '0px',
        }}
        display={
          // Framer Motion sometimes sets the `display` property when this
          // component is nested in an `AnimatePresence`, so this ensures the
          // `display` style prop always takes precedence
          mapResponsive(d => `${d ?? 'flex'} !important`, display)
        }
        position="relative"
        {...props}
        ref={ref}
      >
        <AnimatePresence initial={false}>
          {isVisible && (
            <MaterialCalloutButton
              calloutUrl={materialCallout}
              isLoading={isCustomizing}
              position="absolute"
              top={0}
              {...fadePresence}
            />
          )}
        </AnimatePresence>
      </MotionCenter>
    </Motion.Soft>
  );
});
